import { atom, selector } from "recoil"

export const isToastActiveAtom = atom<boolean>({
  key: "isToastActiveAtom",
  default: false
})

const toastActiveIdAtom = atom<string>({
  key: "toastActiveIdAtom",
  default: ""
})

type ToastActiveSelectorProps = { toastId: string; isActive: boolean }

export const toastActiveSelector = selector<ToastActiveSelectorProps>({
  key: "collapseButtonSelector",
  get: ({ get }) => {
    return { isActive: get(isToastActiveAtom), toastId: get(toastActiveIdAtom) }
  },
  set: ({ set, get }, { isActive, toastId }: ToastActiveSelectorProps) => {
    const existingToastId = get(toastActiveIdAtom)
    if (isActive) {
      set(isToastActiveAtom, isActive)
      set(toastActiveIdAtom, toastId)
    } else {
      if (existingToastId === toastId) {
        set(isToastActiveAtom, isActive)
      }
    }
  }
})
